import {  createSlice } from "@reduxjs/toolkit";
import {  stateEnum } from "../constants/enum"
const { receiveEntry } = stateEnum
const initialState = {
    detailParams: {},
    isNewEntry: false,
    recVouDetail: [],
    isRediOutstanding: false
}



const receiveEntrySlice = createSlice({
    name: receiveEntry,
    initialState,
    reducers: {
        resetDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },
        setVouReportDetail: (state, action) => {
            state.recVouDetail = [action.payload]
        },
        resetRecVouDetail: (state, action) => {
            state.recVouDetail = []
        },
         setIsRediOutstanding: (state, action) => {
            state.isRediOutstanding = action.payload
        }
       

    },
   
})

export const { resetDetailParams, setNewEntryMode, setIsRediOutstanding,setVouReportDetail, resetRecVouDetail, setDetailParams } = receiveEntrySlice.actions

export default receiveEntrySlice.reducer

